import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-termini-condizioni',
  templateUrl: './termini-condizioni.component.html',
  styleUrls: ['./termini-condizioni.component.scss']
})
export class TerminiCondizioniComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/termini-condizioni/termini-condizioni.component.ts